module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Router2-8eb1e52dd36299f24735eeb8c2f0a232.svg";